/**
 * Tracking plan path based on environment, only two exist.
 */
let trackingPlanInstance = 'prod/';
if (__DEV__) {
  trackingPlanInstance = 'e2e/';
}

/**
 * Creates the dynamic tracking plan configuration url
 */
export const dynamicUrl = (defaultProperties) =>
  'https://uxfabric.intuitcdn.net/dtc/' +
  trackingPlanInstance +
  defaultProperties.event_sender_asset_name +
  '/' +
  defaultProperties.event_sender_name +
  '/' +
  defaultProperties.event_sender_asset_version +
  '/config.json';
